/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 13.10.2016.
 */

import PurchaseReducer from './reducer-purchase';

export default PurchaseReducer;



// WEBPACK FOOTER //
// ./src/reducers/purchase/index.js